import React from "react";
import { Link } from 'react-router-dom';
const QuizQuestion = () => {
    return (
        <div className="flex justify-center items-center min-h-screen"> <main className="bg-white p-6 sm:p-8 w-full max-w-7xl"> <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
        Lesson 1: What is the Science of Reading? </h3>
        <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">Checkpoint</h3>

        <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
            <p>
                Directions: Reflecting on the information you learned about the Science of Reading, answer the following questions.
                <br />
                <span className="italic text-gray-600 text-sm">
          (You are required to score 90% or more to pass this section.)
        </span>
            </p>
        </div>

        {/* Main Question Card */}
        <div className="bg-white rounded-xl shadow-md border border-primary p-4 sm:p-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                {/* Column 1: Question */}
                <div className="flex items-center justify-center text-center lg:text-left">
                    <div className="flex flex-col sm:flex-row items-center gap-4">
                        <div className="text-[60px] sm:text-[100px] font-light leading-none text-gray-800">1.</div>
                        <p className="text-base sm:text-lg text-gray-700 leading-snug max-w-xs mt-2 sm:mt-10">
                            For the Science of Reading, which of the following are the two areas of focus?
                        </p>
                    </div>
                </div>

                {/* Column 2: Answers */}
                <div className="space-y-4">
                    {/* Option 1 */}
                    <div className="relative rounded-xl border border-gray-300 bg-white hover:border-gray-400 transition-all cursor-pointer">
                        <div className="flex items-center p-4 sm:p-5 gap-4">
                            <div className="w-6 h-6 rounded-full border-2 border-gray-400 flex-shrink-0"></div>
                            <span className="text-gray-800 text-base sm:text-lg">
                Explicit and systematic instruction of key literacy skills
              </span>
                        </div>
                    </div>

                    {/* Option 2 */}
                    <div className="relative rounded-xl border border-gray-300 bg-white hover:border-gray-400 transition-all cursor-pointer">
                        <div className="flex items-center p-4 sm:p-5 gap-4">
                            <div className="w-6 h-6 rounded-full border-2 border-gray-400 flex-shrink-0"></div>
                            <span className="text-gray-800 text-base sm:text-lg">
                Understanding how the brain learns to read
              </span>
                        </div>
                    </div>

                    {/* Option 3 (Correct) */}
                    <div className="relative rounded-xl border-2 border-greenDark bg-greenLight transition-all">
                        <div className="flex items-center p-4 sm:p-5 gap-4">
                            <div className="w-6 h-6 rounded-full border-2 border-greenDark bg-green flex-shrink-0 flex items-center justify-center">
                                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 16 16">
                                    <circle cx="8" cy="8" r="3" />
                                </svg>
                            </div>
                            <span className="text-green-700 flex-1 text-base sm:text-lg font-medium">
                Explicit and systematic instruction of key literacy skills
              </span>
                            <div className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-greenDark rounded-full p-1.5">
                                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* Option 4 (Incorrect) */}
                    <div className="relative rounded-xl border-2 border-red-500 bg-red-50 transition-all">
                        <div className="flex items-center p-4 sm:p-5 gap-4">
                            <div className="w-6 h-6 rounded-full border-2 border-red-500 flex-shrink-0"></div>
                            <span className="text-red-600 flex-1 text-base sm:text-lg font-medium">
                Whole language approach with less phonics emphasis
              </span>
                            <div className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-red-600 rounded-full p-1.5">
                                <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Next Button */}
        <div className="flex justify-center sm:justify-end mt-6">
            <Link to={'/dashboard/modules/quiz-pass'}>
                <button className="bg-green hover:bg-greenDark text-white font-medium px-8 py-3 rounded-full shadow-md transition-colors flex items-center gap-2">
                    Next Question
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                    </svg>
                </button>
            </Link>
        </div>
    </main>
    </div>

);
};

export default QuizQuestion;
